import { COLORS } from '@getmayday/vue-modules/theme';

export function sentimentsList(index: number = 0) {
  const list = [
    { tokenClass: 'bg-red-1 text-red-9', color: COLORS.red[1] },
    { tokenClass: 'bg-orange-1 text-orange-9', color: COLORS.orange[1] },
    { tokenClass: 'bg-yellow-1 text-yellow-9', color: COLORS.yellow[1] },
    {
      tokenClass: 'bg-blue-1 text-blue-9',
      color: COLORS.blue[0.5],
    },
    { tokenClass: 'bg-green-1 text-green-9', color: COLORS.green[1] },
  ];

  return list[index];
}
